export default "__VITE_ASSET__DcuTmNzJ__"